import { Button, Tooltip } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { useTranslation } from 'react-i18next'

import { DELETE_SHORTCUT } from '../../../../constants/shortcuts'
import { useBillForm } from '../BillEditableForm/contexts/billFormContext'

interface BillDeleteActionProps {
  onClick?: () => void
  tooltipMessage?: string
}

export const BillDeleteAction = ({ onClick, tooltipMessage }: BillDeleteActionProps): ReactElement => {
  const { t } = useTranslation()
  const { processingAction, bulkEditMode, isFetching, isSyncedToCPA } = useBillForm()

  const isButtonDisabled = isFetching || !!processingAction || isSyncedToCPA

  const handleDeleteShortcut = useCallback(() => {
    onClick?.()
  }, [onClick])

  useHotkeys(
    DELETE_SHORTCUT,
    handleDeleteShortcut,
    { enabled: !isButtonDisabled, enableOnTags: ['INPUT', 'TEXTAREA', 'SELECT'] },
    [handleDeleteShortcut],
  )
  return (
    <>
      <Tooltip label={tooltipMessage || t('bill.action.delete')} forceHidden={!isButtonDisabled} placement="bottom">
        {bulkEditMode ? (
          <Button disabled={isButtonDisabled} icon="trash" onClick={onClick} variant="outlined" />
        ) : (
          <Button disabled={isButtonDisabled} icon="trash" onClick={onClick} variant="outlined">
            {t('bill.action.delete')}
          </Button>
        )}
      </Tooltip>
    </>
  )
}
